export default function arrayOfObjectToArray(values: any[], name:any): (string | number)[] {
    return values.map((value) => {
        return value[name];
      });
}